import client from "~/apis/client"

export function fetchGuestReminders() {
  return client.get("/guest_reminders")
}

export function dismissGuestReminder(id) {
  return client.patch(`/guest_reminders/${id}/dismiss`)
}

export function snoozeGuestReminder(id, until) {
  return client.patch(`/guest_reminders/${id}/snooze`, { until })
}
